<mat-dialog-content>
  <form [formGroup]="commissionEditForm" (ngSubmit)="onSubmit()" class="i2Tech-form">
    <div *ngIf="specialRate && !isFixedType" class="form-warning">O parceiro possui alíquota especial de {{specialRate | mask:'separator.2'}}%</div>

    <div class="mb-3">
      <label for="commissionType" class="form-label">Tipo de Comissão</label>
      <select formControlName="commissionType"
              class="form-control"
              (change)="onCommissionTypeChange($any($event.target).value)">
        <option [value]="variableCommissionType">Percentual</option>
        <option [value]="fixedCommissionType">Fixo</option>
      </select>
    </div>

    <div class="mb-3">
      <label for="masterPartnerCommission" class="form-label">
        {{ isFixedType ? 'Valor Fixo do Parceiro Master' : 'Comissão do Parceiro Master' }}
      </label>
      <ng-container *ngIf="!isFixedType; else fixedCommissionField">
        <input formControlName="masterPartnerCommission"
               type="text"
               class="form-control"
               appPercentMask
               required />
      </ng-container>
      <ng-template #fixedCommissionField>
        <app-c-input class="fixed-commission-input"
                     formControlName="masterPartnerCommission"
                     label="master-fixed"
                     [index]="1"
                     alignItem="flex-start"
                     inputMask="separator.2"
                     [required]="true"
                     [currencyMask]="true"
                     [readonly]="false"></app-c-input>
      </ng-template>
      <div *ngIf="hasError('masterPartnerCommission', 'required')" class="form-error">
        O campo <strong>{{ isFixedType ? 'Valor Fixo do Parceiro Master' : 'Comissão do Parceiro Master' }}</strong> é obrigatório.
      </div>
    </div>

    <div *ngIf="hasSubstitutedBeneficiary" class="mb-3">
      <label for="substitutedPartnerCommission" class="form-label">
        {{ isFixedType ? 'Valor Fixo do Parceiro Substabelecido' : 'Comissão do Parceiro Substabelecido' }}
      </label>

      <ng-container *ngIf="!isFixedType; else fixedSubstitutedCommissionField">
        <input formControlName="substitutedPartnerCommission"
               type="text"
               class="form-control"
               appPercentMask
               required />
      </ng-container>

      <ng-template #fixedSubstitutedCommissionField>
        <app-c-input class="fixed-commission-input"
                     formControlName="substitutedPartnerCommission"
                     label="sub-fixed"
                     [index]="2"
                     alignItem="flex-start"
                     inputMask="separator.2"
                     [required]="true"
                     [currencyMask]="true"
                     [readonly]="false"></app-c-input>
      </ng-template>

      <div *ngIf="hasError('substitutedPartnerCommission', 'required')" class="form-error">
        O campo <strong>{{ isFixedType ? 'Valor Fixo do Parceiro Substabelecido' : 'Comissão do Parceiro Substabelecido' }}</strong> é obrigatório.
      </div>
    </div>
    <div class="mb-3">
      <label for="agreementDocument" class="form-label">
        Documento de Acordo
      </label>
      <input formControlName="agreementDocument"
             type="file"
             class="form-control"
             (change)="onFileSelected($event)"
             required />
      <div *ngIf="hasError('agreementDocument', 'required')" class="form-error">
        O campo <strong>Documento de Acordo</strong> é obrigatório.
      </div>
    </div>
    <div class="mb-3">
      <label for="justification" class="form-label">Justificativa</label>
      <textarea id="justification" formControlName="justification" class="form-control" rows="3" required></textarea>
      <div *ngIf="hasError('justification', 'required')" class="form-error">
        O campo <strong>Justificativa</strong> é obrigatório.
      </div>
    </div>
    <div class="horizontal-container">
      <button type="button" class="ui-btn ui-btn--secondary" style="width: 45%;"
              (click)="closeDialogCommissionEdit()">
        Cancelar
      </button>
      <button type="submit" class="ui-btn ui-btn--primary" style="width: 50%;">Salvar Alterações</button>
    </div>
  </form>
</mat-dialog-content>
